export function hasHitPlanLimitForCtaImpressions(
    numberOfImpressionsUsed = 0,
    numberOfMayImpressions = 999999999
): boolean {
    return numberOfImpressionsUsed >= numberOfMayImpressions;
}
